export default __webpack_public_path__ + "static/media/logo-icon.efd64bd0.svg";